import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { getLatestNews, getLatest, formatViews } from "@/lib/content";

export default function LatestNewsSection() {
  const news = getLatestNews(7);
  const hotList = [...getLatest(50)].sort((a, b) => b.views - a.views).slice(0, 5);
  const tags = [
    "新能源",
    "SUV",
    "轿车",
    "智能驾驶",
    "混动",
    "价格战",
    "充电",
    "续航",
  ];

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 mt-14">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <SectionHeading
            title="最新新闻"
            subtitle="按发布时间降序排列，第一时间掌握车市动态"
            moreTo="/news"
          />
          <div className="flex flex-col gap-4">
            {news.map((item) => (
              <ArticleCard key={item.id} article={item} variant="row" />
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="bg-background-50 border border-background-200 rounded-lg p-5">
            <h3 className="font-heading font-semibold text-lg text-foreground-950 flex items-center gap-2 mb-4">
              <i className="ri-fire-line text-accent-500" />
              热门阅读榜
            </h3>
            <ol className="flex flex-col gap-4">
              {hotList.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="group flex gap-3 cursor-pointer"
                  >
                    <span
                      className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                        i < 3
                          ? "bg-accent-500 text-primary-950"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm text-foreground-900 line-clamp-2 group-hover:text-primary-700 transition-colors">
                        {item.title}
                      </span>
                      <span className="block text-xs text-foreground-500 mt-1 flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {formatViews(item.views)} 次阅读
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-5">
            <h3 className="font-heading font-semibold text-lg text-foreground-950 flex items-center gap-2 mb-4">
              <i className="ri-hashtag text-primary-500" />
              热门标签
            </h3>
            <div className="flex flex-wrap gap-2">
              {tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="px-3 py-1 rounded-full text-sm bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}